module.exports = __webpack_public_path__ + "static/media/music-min.42790c89.jpg";